<mb-dynamic-container [observedWidths]="controlBreakpoints" (widthChanged)="checkControlWidth($event)">
  <div
    class="inline-video-container"
    (mouseenter)="hoverPlayer()"
    (mouseleave)="stopHoverplay()"
    (mousemove)="showControls()"
    (click)="showControls()"
  >
    <div class="inline-video-wrapper" #videoParent (click)="togglePlay()"></div>
    @if (!hideTitle || showBackButton) {
      <div class="video-title-wrapper video-title-wrapper-top" [class.player-hovered]="showControls$ | async">
        @if (showBackButton) {
          <span class="video-title-btn btn btn-plain" (click)="backButton.emit()">
            <span class="mb-icon mb-icon-step-back"></span>
          </span>
        }
        @if (!hideTitle) {
          <span [innerHTML]="media.title"></span>
        }
      </div>
    }
    @if (!hideBottomTitle) {
      <div
        class="video-title-wrapper video-title-wrapper-bottom font-family-title h2"
        [class.hidden]="smallControls"
        [class.paused]="($safeNavigationMigration(player?.playing$) | async) === false"
        [innerHTML]="media.title"
      ></div>
    }
    @if (player && controls && !hoverVideo) {
      <mb-video-controls
        [player]="player"
        [media]="media"
        [allowPictureInPicture]="allowPictureInPicture"
        (capture)="capture.emit($event)"
        [smallControls]="smallControls"
        [showControls]="(showControls$ | async) || (player.playing$ | async) === false"
      ></mb-video-controls>
    }
  </div>
  @if (hoverVideo && ($safeNavigationMigration(player?.playing$) | async) === false) {
    <div class="play-pause-btn-container">
      <div class="btn btn-plain">
        <span class="mb-icon mb-icon-player-play"></span>
      </div>
    </div>
  }
</mb-dynamic-container>
